import { render, staticRenderFns } from "./public-holidays.vue?vue&type=template&id=87ab1082&"
import script from "./public-holidays.vue?vue&type=script&lang=js&"
export * from "./public-holidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports